import DefaultView from 'nette-back-module/js/views/back.default'
import merge from 'lodash/merge'
import { watch } from 'vue'
import $ from 'cash-dom'
import NetteAjax from 'nette-base-module/js/nette/NetteAjax'
import draggedElementsIds from 'nette-back-module/js/composables/AwTreeDraggable'

// function for getting flattened array of tree items
const toListArray = (items, parentId = null) => {
  let newItems = []
  let rank = 0
  for (const i in items) {
    if (draggedElementsIds.has(items[i].id)) {
      newItems.push({
        i: items[i].id,
        p: parentId,
        r: rank,
      })
    }

    if (items[i].children && items[i].children.length) {
      newItems = newItems.concat(toListArray(items[i].children, items[i].id))
    }
    rank++
  }

  return newItems
}

export default merge({
  mounted () {
    if (this.$el?.id === 'snippet-moduleActionsContent-buttons') {
      let oldItems = null
      
      watch(() => this.$controls['tree' + this._snippetName]?.sort, (newVal, oldVal) => {
        console.log('watch', newVal, oldVal)
        if (newVal === 'started') {
          if (oldItems === null) {
            oldItems = JSON.stringify(this.$controls['tree' + this._snippetName].items)
          }
        } else if (newVal === 'ended') {
          if (JSON.stringify(this.$controls['tree' + this._snippetName].items) === oldItems) {
            oldItems = null
          }
        } else if (newVal === 'sorted') {
          $(this.$el).find('#sortable-revert').show().off('click').on('click', (e) => {
            e.stopPropagation()
            e.preventDefault()
            this.$store.dispatch('nette/updateControl', {
              controlName: 'tree' + this._snippetName,
              data: JSON.parse(oldItems),
              key: 'items'
            })
            $(this.$el).find('#sortable-revert').hide()
            $(this.$el).find('#sortable-save').hide()
          })

          $(this.$el).find('#sortable-save').show().off('click').on('click', (e) => {
            e.stopPropagation()
            e.preventDefault()
            NetteAjax.post(
              $(this.$el).find('#sortable-save').attr('href'),
              { items: JSON.stringify(toListArray(this.$controls['tree' + this._snippetName].items)) }
            )

            draggedElementsIds.clear()
            oldItems = null
            $(this.$el).find('#sortable-revert').hide()
            $(this.$el).find('#sortable-save').hide()
          })
        }
      }, {
        deep: true
      })

      $(this.$el).find('#sortable-revert').hide()
      $(this.$el).find('#sortable-save').hide()
    }
  }
}, DefaultView)